/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type InsightsExportEstimateSchemaAvailableSectionsItem = typeof InsightsExportEstimateSchemaAvailableSectionsItem[keyof typeof InsightsExportEstimateSchemaAvailableSectionsItem];


export const InsightsExportEstimateSchemaAvailableSectionsItem = {
  top_locations: 'top_locations',
  smart_overview: 'smart_overview',
  experience_stats: 'experience_stats',
  tenure_stats: 'tenure_stats',
  experience_chart: 'experience_chart',
  top_skills: 'top_skills',
  top_job_titles: 'top_job_titles',
  current_employers: 'current_employers',
  past_employers: 'past_employers',
  title_levels: 'title_levels',
  gender: 'gender',
  industries: 'industries',
  top_languages: 'top_languages',
  top_universities: 'top_universities',
  education: 'education',
} as const;
